module.exports = __webpack_public_path__ + "static/media/Loading_icon.584b607f.gif";